module.exports = __webpack_public_path__ + "static/portfolio-top-remit-0ebe35d81fcbb58d3a8016db7798a11b.png";